import { CardInfoTranslationDto } from "@dtos/card-info-translation.dto";
import { BaseConverter } from "@converter/BaseConverter";
import { CardInfoTranslation } from "@models/card-info-translation.model";
import { CardInfoConverter } from "@converter/cardInfoConverter";

export class CardInfoTranslationConverter extends BaseConverter<CardInfoTranslation, CardInfoTranslationDto>{
   
    private cardInfoConverter = new CardInfoConverter()

    modelToDto(model: CardInfoTranslation): CardInfoTranslationDto {
        return new CardInfoTranslationDto(
            model.id,
            model.locale,
            model.title,
            model.cardInfo ? this.cardInfoConverter.modelToDto(model.cardInfo) : undefined 
        )
    }

    dtoToModel(dto: CardInfoTranslationDto): CardInfoTranslation {
        return new CardInfoTranslation(
            dto.id,
            dto.locale,
            dto.title,
            dto.cardInfo ? this.cardInfoConverter.dtoToModel(dto.cardInfo) : undefined
        )
    }
}